"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * (c) 2021, Micro:bit Educational Foundation and contributors
 *
 * SPDX-License-Identifier: MIT
 */
const fonts = {
    heading: "Roboto, Helvetica, Arial, sans-serif",
    body: "Roboto, Helvetica, Arial, sans-serif",
    code: "Source Code Pro, monospace",
};
exports.default = fonts;
